import backgroundGlow from './background-glow.svg';
import fingerprintIcon from './fingerprint-icon.svg';
import globalIcon from './global-icon.svg';
import serviceIcon from './service-icon.svg';
import subtract from './subtract.svg';
import tagIcon from './tag-icon.svg';
import untitled22 from './untitled-2-2.png';

export const aboutSectionAssets = {
  untitled22: untitled22.src,
  backgroundGlow: backgroundGlow.src,
  tagIcon: tagIcon.src,
  fingerprintIcon: fingerprintIcon.src,
  globalIcon: globalIcon.src,
  serviceIcon: serviceIcon.src,
  subtract: subtract.src,
};
